import * as common from '@/util/common'

export default {
  data() {
    return {
      visibleSystemError: false // システムエラー画面
    }
  },
  mounted () {
  },
  methods: {
    scrollAreaTop: function(target) {
      common.scrollAreaTop(target)
    }
  }
}
